//import { lighten, darken } from 'polished';
//
//const brand = '#ff5a5e';
//const select = '#0098ac';
//const warning = '#ff4a4a';
//const encourage = '#3ccc3b';
//const assist = '#ffab1a';
//const money = '#ff8000';
export default {
    brand: '#00a5aa',
    brandHover: '#33b7bb',
    brandActive: '#007c85',
    disabled: '#B6BBC7',
    select: '#00a5aa',
    selectHover: '#33b7bb',
    selectActive: '#007c85',
    warning: '#ff4a4a',
    warningHover: '#ff6e6e',
    warningActive: '#d8343a',
    encourage: '#3ccc3b',
    encourageHover: '#63d662',
    encourageActive: '#33a731',
    assist: '#ffab1a',
    assistHover: '#ffbb47',
    assistActive: '#e69200',
    money: '#ff5000',
    moneyHover: '#ff7333',
    moneyActive: '#d93d00',
    mainText: '#101934',
    secondaryText: '#747a8c',
    disabledText: '#ced1d7',
    assistText: '#868da1',
    assistDefaultText: '#b6bbc7',

    hover: '#ebf7f9',
    selected: '#f7f7f7',
};
